module.exports = __webpack_public_path__ + "img/eventtype-error.dc141f93.svg";